/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * Check payment type
 * @nullable
 */
export type CreateManualInvoiceRequestCheckMethod = typeof CreateManualInvoiceRequestCheckMethod[keyof typeof CreateManualInvoiceRequestCheckMethod] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateManualInvoiceRequestCheckMethod = {
  offline: 'offline',
  mercury: 'mercury',
  fulfill: 'fulfill',
  print: 'print',
} as const;
